import styles from './finished-quotations.module.css';
import { ListTable } from '../../../../../../shared/ListTable';
import { FinishedQuotationRow } from '../../components/FinishedQuotationRow';
import AnsweredQuotationsIcon from '../../../../../../assets/icons/answered-quotations.svg';
import { useFinishedQuotations } from './useFinishedQuotations';
import { ViewFinishedQuotation } from '../../components/modals/ViewFinishedQuotation';
import { sendWhatsappMessage } from '../../../../../../utils/sendWhatsappMessage';
import { useResponsive } from '../../../../../../hooks/useResponsive';
import { useFilteredAnswers } from '../../hooks/useFilteredAnswers';
import { FilterComponent } from '../../../../../../shared/FilterComponent';
import { GetMyAnswerFilters } from '../../interface';

export const FinishedQuotations = () => {
  const {
    finishedQuotations,
    isLoading,
    loadMoreData,
    page,
    selectedAnswerToView,
    setSelectedAnswerToView,
    isViewQuotationModalOpen,
    setIsViewQuotationModalOpen,
    handleRowClick,
    searchedQuotation,
    setSearchedQuotation,
  } = useFinishedQuotations();
  const { sizeMobile } = useResponsive();

  const {
    filterType,
    filterValue,
    handleDateSearch,
    handleSearch,
    searchedAnswers,
    setFilterType,
  } = useFilteredAnswers({
    option: 'finished',
  });

  return (
    <>
      <ViewFinishedQuotation
        isOpen={isViewQuotationModalOpen}
        onClose={() => {
          setSelectedAnswerToView(null);
          setIsViewQuotationModalOpen(false);
          setSearchedQuotation(null);
        }}
        quotationAnswer={searchedQuotation}
      />
      <div className={styles.heading}>
        <div className={styles.describe}>
          <img src={AnsweredQuotationsIcon} alt="cotações criadas" />
          <p>Cotações concluídas</p>
        </div>
        <div className={styles.actions}>
          <FilterComponent
            handleDateSearch={handleDateSearch}
            handleSearch={handleSearch}
            handleFilterChange={(filter: string) =>
              setFilterType(filter as GetMyAnswerFilters)
            }
            defaultValue="code"
            variant={filterType === 'date_recieved' ? 'date' : 'searchbar'}
            onlyNumber={filterType === 'code'}
            options={[
              {
                label: 'Número',
                value: 'code',
              },
              {
                label: 'Data',
                value: 'date_recieved',
              },
              {
                label: 'Placa',
                value: 'plate',
              },
              {
                label: 'Origem',
                value: 'origin',
              },
            ]}
          />
        </div>
      </div>
      <ListTable.Root
        isLoading={isLoading}
        isEmpty={!isLoading && finishedQuotations.length === 0}
        notFound={filterValue.trim().length > 0 && searchedAnswers.length === 0}
        message="Nenhuma Cotação Encontrada"
      >
        <div className={styles.container}>
          <ListTable.Head
            style={{
              gridTemplateColumns: sizeMobile
                ? 'repeat(3, 1.5fr) 2.5fr'
                : '1fr 2.5fr 1fr 1fr',
            }}
          >
            <ListTable.HeadItem>
              {sizeMobile ? 'N° de cotação' : 'Número de cotação'}
            </ListTable.HeadItem>
            <ListTable.HeadItem>Data de Criação</ListTable.HeadItem>
            <ListTable.HeadItem>Data da Finalização</ListTable.HeadItem>
            <ListTable.HeadItem>Origem</ListTable.HeadItem>
          </ListTable.Head>
          <ListTable.Body onScroll={() => loadMoreData(page)}>
            {/* if user has searched something it shows the response */}
            {(filterValue.trim().length > 0
              ? searchedAnswers
              : finishedQuotations
            ).map(answer => (
              <FinishedQuotationRow
                key={answer.id_answer_quotation}
                answer={answer}
                handleView={() => setIsViewQuotationModalOpen(true)}
                handleWhatsapp={() =>
                  sendWhatsappMessage(
                    `Olá *${
                      answer?.quotation?.workshop?.fantasy_name ?? ''
                    }* , gostaria de informações sobre a cotação *n° ${
                      answer?.quotation?.QUOTATION ?? ''
                    }*`,
                    answer.workshop?.whatsapp ?? '',
                  )
                }
                onRowClick={() => handleRowClick(answer)}
                isSelected={
                  !!selectedAnswerToView &&
                  selectedAnswerToView.quotation_id === answer.quotation_id
                }
              />
            ))}
          </ListTable.Body>
        </div>
      </ListTable.Root>
    </>
  );
};
